<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date"
            :label="getLabel"
            readonly
            v-bind="attrs"
            v-on="on"
            :full-width="true"
            :value="value"
            :clearable="clearable"
            @click:clear="onInput('')"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(date); onInput(date)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
</template>

<script>
export default {
    name: 'InputDataPicker',
    props: {
        label: {
            type: String,
        },
        value: {
            type: String,
        },
        showCurrentDate: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: true,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
             menu: null,
             date: this.showCurrentDate ? (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10) : this.value,
        };
    },
    computed: {
        getLabel() {
            return this.label ? this.label : this.$t('fields.date');
        },
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
